<template>
    <div class="main">

        <a-card
                class="lists"
                hoverable
                v-infinite-scroll="loadmore"
                :infinite-scroll-disabled="busy"
                :infinite-scroll-distance="10"
        >
            <a-spin :spinning="spinning" style="width: 100%">
                <div v-for="(item,index) in lists" :key="index" @click="selectRow(index)" class="row" :class="[currentId == index ? 'active current' : '']">
                    <a-row class="title">{{ item.title }}</a-row>
                    <a-row class="info" :class="[currentId == index ? 'active' : '']">
                        <a-col :span="12" class="pubtime">{{ item.addtime }}</a-col>
                        <a-col :span="12" class="user">来源：{{ item.comefrom }}</a-col>
                    </a-row>
                </div>
            </a-spin>
        </a-card>
        <div class="detail">
            <div class="toolbar">
                <div class="menu edit"><a-icon type="edit" theme="twoTone" twoToneColor="#52c41a" />选用</div>
                <div class="menu" :class="{current : index == 4}" @click="logShow" style="width: 100px"><a-icon type="file-text" />选用记录</div>
            </div>
            <div class="title"><h1>{{ article.title }}</h1></div>
            <div class="info"><span>来源：{{ article.comefrom }}</span><span>更新时间：{{ article.addtime }}</span></div>
            <div class="content" v-html="article.content"></div>
        </div>
        <div class="logs" v-show="showLog">
            <a-card hoverable>
                <a-timeline class="log-content">
                    <a-timeline-item color="green">Create a services site 2015-09-01</a-timeline-item>
                    <a-timeline-item color="green">Create a services site 2015-09-01</a-timeline-item>
                    <a-timeline-item color="red">
                        <p>Solve initial network problems 1</p>
                        <p>Solve initial network problems 2</p>
                        <p>Solve initial network problems 3 2015-09-01</p>
                    </a-timeline-item>
                    <a-timeline-item>
                        <p>Technical testing 1</p>
                        <p>Technical testing 2</p>
                        <p>Technical testing 3 2015-09-01</p>
                    </a-timeline-item>
                    <a-timeline-item color="green">Create a services site 2015-09-01</a-timeline-item>
                    <a-timeline-item color="green">Create a services site 2015-09-01</a-timeline-item>
                </a-timeline>
            </a-card>
        </div>
    </div>

</template>

<script>
    import infiniteScroll from 'vue-infinite-scroll'
    import moment from 'moment';


    export default {
        name: "Lists",
        directives: { infiniteScroll },
        data() {
            return {
                param: {page: 1,channel_id:57560, limit:20},
                spinning: false,
                lists:[],
                currentId:0,
                loading: false,
                busy: false,
                id: 0,
                showLog: false,
                index:0,
                article:{},

            }
        },
        watch: {
            $route(){
                this.spinning = false
                this.lists = []
                this.currentId = 0
                this.loading = false
                this.busy = false
                this.id = 0
                this.showLog = false
                this.in = 0
                this.article = {}
                this.param = {page: 1,channel_id:this.$route.query.id, limit:20},
                this.getLists()
            },
        },
        created() {
            if (typeof this.$route.query.id != 'undefined' && this.$route.query.id != '') {
                this.param.channel_id = this.$route.query.id
            }
        },
        methods: {
            moment,
            loadDetail(id){
                this.$http.post('/api/report/detail',{id:id})
                    .then(res=>{
                        if (res.data.state == 200) {
                            this.article = res.data.data
                        }
                    })
            },

            loadmore(){
                if (!this.loading) {
                    this.getLists()
                }
            },
            selectRow(index){
                // this.article = this.lists[index]
                this.currentId = index
                this.loadDetail(this.lists[index].id)
            },

            logShow(){
                this.showLog = !this.showLog
                this.index = this.showLog ? 4 : 0
            },
            getLists() {
                this.busy = true
                if (!this.spinning) {
                    this.spinning = true
                    this.$http.post('/api/report/lists', this.param)
                        .then(res => {
                            if (res.data.state == 200) {

                                for (let i in res.data.data) {
                                    let data =res.data.data[i]
                                    if (this.lists.length == 0) this.loadDetail(res.data.data[0].id)
                                    // data.PubTime = moment(res.data.data[i].PubTime).format('YYYY-MM-DD hh:mm:ss')
                                    this.lists.push(data)
                                }
                                if (this.lists.length < res.data.pages) {
                                    this.param.page ++
                                } else{
                                    this.loading = true
                                    this.$message.warn('所有数据都已加载完毕')
                                }
                                this.spinning = false
                                this.busy = false

                            }
                        })
                }

            }
        }
    }
</script>

<style scoped>
    .main {
        position: absolute;
        top: 0px;
        right: 0;
        bottom: 0;
        left: 0;
        overflow-y: auto;
        background-color: #fff;
        /*padding-top:10px*/
    }

    .lists{
        width: 360px;
        position: absolute;
        top:0;
        right: 0;
        bottom: 0;
        left: 0;
        overflow-y: auto;

    }
    .row {
        padding: 5px;
        height: 80px;
        line-height: 24px;
        border-bottom: 1px solid #E8E8E8;
    }
    .current {
        background-color: #409EFF;
    }

    .active,.active>.pubtime,.active>.user {
        color:#fff;
    }

    .row .title {
        padding: 0 5px;
        font-size: 16px;
        height:50px;
    }


    .row .title i{
        margin-right: 5px;
    }

    .row .info{
        padding: 0 5px;
        font-size: 13px;
        height: 24px;
        line-height: 24px;
        color:#C0C4CC;
    }

    .row .info .pubtime{
        text-align: left;
    }
    .row .info .user{
        text-align: right;
    }

    .detail {
        position: absolute;
        left:370px;
        right:0px;
        top: 0;
        bottom: 10px;
        padding-right:10px;
        overflow-x: hidden;
        overflow-y: auto;
    }
    .detail .toolbar {
        text-align: right;
        height: 50px;
        line-height: 50px;
        border-bottom: 1px solid #E8E8E8;

    }
    .detail .toolbar i{
        margin-right: 5px;
    }

    .detail .toolbar .menu {
        float: right;
        cursor: pointer;
        text-align: center;
        height: 50px;
        line-height: 50px;
        width: 70px;
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Chrome/Safari/Opera */
        -khtml-user-select: none; /* Konqueror */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none;
    }


    .detail .toolbar .menu:hover,.detail .toolbar .current{
        background-color: #eeeeee;
    }
    .logs {
        background-color: #fff;
        position: absolute;
        z-index: 999;
        width: 280px;
        top: 59px;
        right: 10px;
        bottom: 10px;
        overflow-y: auto;
        transition: all 2s;
        -moz-transition: all 2s;	/* Firefox 4 */
        -webkit-transition: all 2s;	/* Safari 和 Chrome */
        -o-transition: all 2s;	/* Opera */
    }
    .log-content {
        padding: 10px 0 0 10px;
    }

    .detail .title{
        line-height: 50px;
        height: 50px;
        white-space:nowrap;
        text-overflow: ellipsis;
        overflow:hidden;
    }

    .detail .info span{
        color: #999aa5;
        margin-right: 10px;
    }
    .detail .content {
        margin-top: 10px;
        font-size: 16px;
        line-height: 28px;
        position: absolute;
        top: 120px;
        right: 0;
        bottom: 0;
        left: 0;
        padding:0 10px;
    }
    .detail .content img{
        text-align:center
    }

    .detail .delete {
        color:#FF6E32;
    }

    .detail .edit {
        color:#52c41a;
    }

</style>
